import { render, staticRenderFns } from "./GroupGrid.vue?vue&type=template&id=61395fa8&scoped=true&"
import script from "./GroupGrid.vue?vue&type=script&lang=ts&"
export * from "./GroupGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GroupGrid.vue?vue&type=style&index=0&id=61395fa8&prod&lang=css&"
import style1 from "./GroupGrid.vue?vue&type=style&index=1&id=61395fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61395fa8",
  null
  
)

export default component.exports